export interface FormFieldConfig {
  id: string;
  label: string;
  type: string;
  placeholder?: string;
}

export interface FormSection {
  title: string;
  fields: FormFieldConfig[];
}

export interface FormConfig {
  sections: FormSection[];
  upload: {
    label: string;
    buttonText: string;
    helperText: string;
    accept: string;
  };
}

export const formConfig: FormConfig = {
  sections: [
    {
      title: '',
      fields: [
        {
          id: 'businessname',
          label: 'Business name',
          type: 'text',
          placeholder: 'Your Company, Inc.',
        },
      ],
    },
    {
      title: 'Business Contact Information',
      fields: [
        {
          id: 'firstname',
          label: 'First name',
          type: 'text',
          placeholder: 'John',
        },
        {
          id: 'lastname',
          label: 'Last name',
          type: 'text',
          placeholder: 'Doe',
        },
        {
          id: 'email',
          label: 'Email',
          type: 'email',
          placeholder: 'john@example.com',
        },
      ],
    },
  ],
  upload: {
    label: 'Certificate of insurance',
    buttonText: 'Upload file(s) or drag and drop here',
    helperText:
      'Upload up to 20 files, maximum total size 100MB. Only PDF files are accepted.',
    accept: 'application/pdf',
  },
};
